export default __webpack_public_path__ + "static/MediaContentOne-b6618d75823871805e19703939943be0.webp";